<div class="row">
    <div class="col-16">
        <div class="input-wrapper">
            <ValidatedTextField class="field field--single"
                                [label]="'Name'"
                                id="name"
                                [text]="powerOfAttorneyModel.name"
                                (onValueChange)="powerOfAttorneyModel.name = $event"
                                [validators]="[notBlankValidator]">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="partition">
    <AddressGroup id="address"
                  [address]="powerOfAttorneyModel.address"
                  (onValueChange)="powerOfAttorneyModel.address = $event">

    </AddressGroup>
</div>

<div class="row">
    <div class="col-16 partition">
        <div class="input-wrapper">
            <MaskedValidatedTextField class="field field--single"
                                      [label]="'Phone Number'"
                                      id="phone-number"
                                      [text]="powerOfAttorneyModel.phone"
                                      [maxlength]="10"
                                      [helperText]="'Please format as ##########'"
                                      [inputMask]="phoneNumberInputMask"
                                      (onValueChange)="powerOfAttorneyModel.phone = $event"
                                      [validators]="[notBlankValidator, phoneNumberValidator, numericValidator]">
            </MaskedValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="input-wrapper">
            <ValidatedDropDown id="relationship"
                               label="Relationship to Enrollee"
                               class="field field--single"
                               [options]="relationships"
                               [selectedValue]="powerOfAttorneyModel.relationship"
                               (onValueChange)="powerOfAttorneyModel.relationship = $event"
                               [validators]="[notBlankValidator]">

            </ValidatedDropDown>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="input-wrapper">
            <input type="checkbox"
                   id="send-duplicate-materials"
                   [ngModel]="powerOfAttorneyModel.sendDuplicateMaterials"
                   (ngModelChange)="powerOfAttorneyModel.sendDuplicateMaterials = $event">
            <label class="field__label--checkboxlabel">Please check if authorized representative should receive duplicate copy of plan materials.</label>
        </div>
    </div>
</div>
